import type { Entitlement } from "@storytell/types";

export type FeatureGateService = ReturnType<typeof createFeatureGateService>;

export const createFeatureGateService = (deps: { entitlements: () => Entitlement[] | undefined }) => {
  const getEntitlement = (feature: string) => deps.entitlements()?.find((e) => e.feature === feature);

  const canAccess = (feature: string): boolean => {
    const ent = getEntitlement(feature);
    if (!ent) return false;
    return ent.accessible;
  };

  // True only when entitlements have loaded AND the feature is denied. Lets the UI
  // hold off on "Pro" badges / upgrade panels until we actually know the answer —
  // otherwise paying users see a flash of the gated state on every cold load.
  const isDenied = (feature: string): boolean => {
    const ents = deps.entitlements();
    if (!ents) return false;
    const ent = ents.find((e) => e.feature === feature);
    return ent !== undefined && !ent.accessible;
  };

  const requiredPlan = (feature: string): string => {
    return getEntitlement(feature)?.requiredPlan ?? "";
  };

  return {
    canAccess,
    isDenied,
    requiredPlan,
  };
};
